var map = {
	"./svg/HTML5.svg": 928,
	"./svg/actix.svg": 929,
	"./svg/aiohttp.svg": 930,
	"./svg/amd.svg": 931,
	"./svg/amixr.svg": 932,
	"./svg/android.svg": 933,
	"./svg/angularjs.svg": 934,
	"./svg/app-engine.svg": 935,
	"./svg/apple.svg": 936,
	"./svg/asana.svg": 937,
	"./svg/asayer.svg": 938,
	"./svg/auth0.svg": 939,
	"./svg/aws.svg": 940,
	"./svg/awslamda.svg": 941,
	"./svg/azure.svg": 942,
	"./svg/backbone.svg": 943,
	"./svg/bitbucket.svg": 944,
	"./svg/bootstrap.svg": 945,
	"./svg/bottle.svg": 946,
	"./svg/campfire.svg": 947,
	"./svg/celery.svg": 948,
	"./svg/chalice.svg": 949,
	"./svg/chrome.svg": 950,
	"./svg/clickup.svg": 951,
	"./svg/clojure.svg": 952,
	"./svg/clubhouse.svg": 953,
	"./svg/connect.svg": 954,
	"./svg/cordova.svg": 955,
	"./svg/csharp.svg": 956,
	"./svg/dart.svg": 957,
	"./svg/datadog.svg": 958,
	"./svg/default.svg": 959,
	"./svg/django.svg": 960,
	"./svg/dotnet.svg": 961,
	"./svg/dotnetcore.svg": 962,
	"./svg/electron.svg": 963,
	"./svg/elixir.svg": 964,
	"./svg/ember.svg": 965,
	"./svg/express.svg": 966,
	"./svg/falcon.svg": 967,
	"./svg/firetv.svg": 968,
	"./svg/flask.svg": 969,
	"./svg/flowdock.svg": 970,
	"./svg/flutter.svg": 971,
	"./svg/fsharp.svg": 972,
	"./svg/fullstory.svg": 973,
	"./svg/gcp.svg": 974,
	"./svg/generic.svg": 975,
	"./svg/github.svg": 976,
	"./svg/gitlab.svg": 977,
	"./svg/go.svg": 978,
	"./svg/google.svg": 979,
	"./svg/heroku.svg": 980,
	"./svg/intellinote.svg": 981,
	"./svg/ios.svg": 982,
	"./svg/java.svg": 983,
	"./svg/javascript.svg": 984,
	"./svg/jira.svg": 985,
	"./svg/koa.svg": 986,
	"./svg/kotlin.svg": 987,
	"./svg/laravel.svg": 988,
	"./svg/lighthouse.svg": 989,
	"./svg/linear.svg": 990,
	"./svg/logback.svg": 991,
	"./svg/msteams.svg": 992,
	"./svg/nativec.svg": 993,
	"./svg/net5.svg": 994,
	"./svg/nextjs.svg": 995,
	"./svg/nodejs.svg": 996,
	"./svg/okta.svg": 997,
	"./svg/onelogin.svg": 998,
	"./svg/opsgenie.svg": 999,
	"./svg/pagerduty.svg": 1000,
	"./svg/perl.svg": 1001,
	"./svg/phabricator.svg": 1002,
	"./svg/php.svg": 1003,
	"./svg/pivotaltracker.svg": 1004,
	"./svg/pushover.svg": 1005,
	"./svg/pyramid.svg": 1006,
	"./svg/python.svg": 1007,
	"./svg/rails.svg": 1008,
	"./svg/react.svg": 1009,
	"./svg/redis.svg": 1010,
	"./svg/redmine.svg": 1011,
	"./svg/redux.svg": 1012,
	"./svg/relay.svg": 1013,
	"./svg/rippling.svg": 1014,
	"./svg/rocketchat.svg": 1015,
	"./svg/rookout.svg": 1016,
	"./svg/ruby.svg": 1017,
	"./svg/rust.svg": 1018,
	"./svg/saml2.svg": 1019,
	"./svg/segment.svg": 1020,
	"./svg/sentry.svg": 1021,
	"./svg/serverless.svg": 1022,
	"./svg/slack.svg": 1023,
	"./svg/split.svg": 1024,
	"./svg/spring.svg": 1025,
	"./svg/springboot.svg": 1026,
	"./svg/sprintly.svg": 1027,
	"./svg/swift.svg": 1028,
	"./svg/symfony.svg": 1029,
	"./svg/taiga.svg": 1030,
	"./svg/teamwork.svg": 1031,
	"./svg/tornado.svg": 1032,
	"./svg/trello.svg": 1033,
	"./svg/tryton.svg": 1034,
	"./svg/twilio.svg": 1035,
	"./svg/unity.svg": 1036,
	"./svg/unreal.svg": 1037,
	"./svg/vercel.svg": 1038,
	"./svg/visualbasic.svg": 1039,
	"./svg/vue.svg": 1040,
	"./svg/windows.svg": 1041,
	"./svg/youtrack.svg": 1042,
	"./svg/zendesk.svg": 1043,
	"./svg/zulip.svg": 1044,
	"./svg_80x80/HTML5.svg": 1732,
	"./svg_80x80/actix.svg": 1733,
	"./svg_80x80/aiohttp.svg": 1734,
	"./svg_80x80/amd.svg": 1735,
	"./svg_80x80/amixr.svg": 1736,
	"./svg_80x80/android.svg": 1737,
	"./svg_80x80/angularjs.svg": 1738,
	"./svg_80x80/app-engine.svg": 1739,
	"./svg_80x80/apple.svg": 1740,
	"./svg_80x80/asana.svg": 1741,
	"./svg_80x80/asayer.svg": 1742,
	"./svg_80x80/auth0.svg": 1743,
	"./svg_80x80/aws.svg": 1744,
	"./svg_80x80/awslamda.svg": 1745,
	"./svg_80x80/azure.svg": 1746,
	"./svg_80x80/backbone.svg": 1747,
	"./svg_80x80/bitbucket.svg": 1748,
	"./svg_80x80/bootstrap.svg": 1749,
	"./svg_80x80/bottle.svg": 1750,
	"./svg_80x80/campfire.svg": 1751,
	"./svg_80x80/celery.svg": 1752,
	"./svg_80x80/chalice.svg": 1753,
	"./svg_80x80/chrome.svg": 1754,
	"./svg_80x80/clickup.svg": 1755,
	"./svg_80x80/clojure.svg": 1756,
	"./svg_80x80/clubhouse.svg": 1757,
	"./svg_80x80/connect.svg": 1758,
	"./svg_80x80/cordova.svg": 1759,
	"./svg_80x80/csharp.svg": 1760,
	"./svg_80x80/dart.svg": 1761,
	"./svg_80x80/datadog.svg": 1762,
	"./svg_80x80/default.svg": 1763,
	"./svg_80x80/django.svg": 1764,
	"./svg_80x80/dotnet.svg": 1765,
	"./svg_80x80/electron.svg": 1766,
	"./svg_80x80/elixir.svg": 1767,
	"./svg_80x80/ember.svg": 1768,
	"./svg_80x80/express.svg": 1769,
	"./svg_80x80/falcon.svg": 1770,
	"./svg_80x80/firetv.svg": 1771,
	"./svg_80x80/flask.svg": 1772,
	"./svg_80x80/flowdock.svg": 1773,
	"./svg_80x80/flutter.svg": 1774,
	"./svg_80x80/fsharp.svg": 1775,
	"./svg_80x80/fullstory.svg": 1776,
	"./svg_80x80/gcp.svg": 1777,
	"./svg_80x80/github-enterprise.svg": 1778,
	"./svg_80x80/github.svg": 1779,
	"./svg_80x80/gitlab.svg": 1780,
	"./svg_80x80/go.svg": 1781,
	"./svg_80x80/google.svg": 1782,
	"./svg_80x80/heroku.svg": 1783,
	"./svg_80x80/intellinote.svg": 1784,
	"./svg_80x80/ios.svg": 1785,
	"./svg_80x80/java.svg": 1786,
	"./svg_80x80/javascript.svg": 1787,
	"./svg_80x80/jira-server.svg": 1788,
	"./svg_80x80/jira.svg": 1789,
	"./svg_80x80/koa.svg": 1790,
	"./svg_80x80/kotlin.svg": 1791,
	"./svg_80x80/laravel.svg": 1792,
	"./svg_80x80/lighthouse.svg": 1793,
	"./svg_80x80/linear.svg": 1794,
	"./svg_80x80/logback.svg": 1795,
	"./svg_80x80/mnet.svg": 1796,
	"./svg_80x80/msteams.svg": 1797,
	"./svg_80x80/nativec.svg": 1798,
	"./svg_80x80/net5.svg": 1799,
	"./svg_80x80/nextjs.svg": 1800,
	"./svg_80x80/nodeglyph.svg": 1801,
	"./svg_80x80/nodejs.svg": 1802,
	"./svg_80x80/objc-cocoa.svg": 1803,
	"./svg_80x80/okta.svg": 1804,
	"./svg_80x80/onelogin.svg": 1805,
	"./svg_80x80/opsgenie.svg": 1806,
	"./svg_80x80/pagerduty.svg": 1807,
	"./svg_80x80/perl.svg": 1808,
	"./svg_80x80/phabricator.svg": 1809,
	"./svg_80x80/php.svg": 1810,
	"./svg_80x80/pivotaltracker.svg": 1811,
	"./svg_80x80/pushover.svg": 1812,
	"./svg_80x80/pyramid.svg": 1813,
	"./svg_80x80/python.svg": 1814,
	"./svg_80x80/rails.svg": 1815,
	"./svg_80x80/react.svg": 1816,
	"./svg_80x80/redis.svg": 1817,
	"./svg_80x80/redmine.svg": 1818,
	"./svg_80x80/redux.svg": 1819,
	"./svg_80x80/relay.svg": 1820,
	"./svg_80x80/rippling.svg": 1821,
	"./svg_80x80/rocketchat.svg": 1822,
	"./svg_80x80/rookout.svg": 1823,
	"./svg_80x80/ruby.svg": 1824,
	"./svg_80x80/rust.svg": 1825,
	"./svg_80x80/saml2.svg": 1826,
	"./svg_80x80/segment.svg": 1827,
	"./svg_80x80/sentry.svg": 1828,
	"./svg_80x80/serverless.svg": 1829,
	"./svg_80x80/slack.svg": 1830,
	"./svg_80x80/split.svg": 1831,
	"./svg_80x80/spring.svg": 1832,
	"./svg_80x80/spring_logo-spring.svg": 1833,
	"./svg_80x80/springboot.svg": 1834,
	"./svg_80x80/sprintly.svg": 1835,
	"./svg_80x80/swift.svg": 1836,
	"./svg_80x80/symfony.svg": 1837,
	"./svg_80x80/taiga.svg": 1838,
	"./svg_80x80/teamwork.svg": 1839,
	"./svg_80x80/tornado.svg": 1840,
	"./svg_80x80/trello.svg": 1841,
	"./svg_80x80/tryton.svg": 1842,
	"./svg_80x80/twilio.svg": 1843,
	"./svg_80x80/unity.svg": 1844,
	"./svg_80x80/unreal.svg": 1845,
	"./svg_80x80/vercel.svg": 1846,
	"./svg_80x80/visualbasic.svg": 1847,
	"./svg_80x80/vue.svg": 1848,
	"./svg_80x80/windows.svg": 1849,
	"./svg_80x80/youtrack.svg": 1850,
	"./svg_80x80/zendesk.svg": 1851,
	"./svg_80x80/zulip.svg": 1852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1731;